<template>
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.6"
      d="M81.1202 39.4519H19.5464V110.086H81.1202V39.4519Z"
      fill="var(--jd-color-line-100)"
    />
    <path
      d="M35.5555 96.4551V39.4519H23.8564L35.5555 96.4551Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M90.6899 100.173L42.2058 100.173C38.6285 100.173 35.7666 97.6645 35.7666 94.5291C35.7666 76.1701 35.7667 57.811 35.7667 39.4519C35.7667 35.9632 35.7667 32.4746 35.7667 28.9859C35.7667 25.8506 33.9816 24.5977 32.9482 23.3423L90.69 23.3423C94.2673 23.3423 97.1292 25.8506 97.1292 28.9859L97.1291 94.5292C97.1291 97.5948 94.2672 100.173 90.6899 100.173Z"
      fill="var(--jd-color-surface-400)"
    />
    <path
      d="M96.617 71.4122V65.9924M96.617 65.9924V100.587H42.0216C38.4298 100.587 35.8642 98.0052 35.8642 93.452L35.8643 29.0259C35.8642 25.5118 33.5959 22.9302 30.22 22.9302H90.5214C93.888 22.9302 96.6171 25.6593 96.6171 29.0259V29.0259L96.617 65.9924Z"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2392"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M30.0378 22.9303C26.1778 22.9304 24.1533 25.9177 24.1533 29.2493L24.0569 39.453H35.5557"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2392"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M41.5249 100.587H96.1092C100.586 100.587 102.78 97.2336 102.78 93.1515V86.1294H48.1843V93.1515C48.2568 97.1607 46.6561 100.587 41.5249 100.587Z"
      fill="var(--jd-color-surface-400)"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2392"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M86.5237 40.2091C80.6855 39.952 75.937 44.3345 75.7008 49.7639C75.4646 55.1933 79.8144 59.9766 85.6525 60.2338C88.0214 60.3382 90.2108 59.6787 91.9923 58.4953L93.3229 57.4442C95.1785 55.7122 96.3605 53.3195 96.4753 50.6791C96.7115 45.2496 92.3618 40.4663 86.5237 40.2091ZM99.829 61.3205C102.191 58.5172 103.682 54.9573 103.854 51.0041C104.277 41.2881 96.5561 33.2382 86.8455 32.8105C77.1349 32.3827 68.7446 39.7228 68.3219 49.4388C67.8992 59.1549 75.62 67.2047 85.3306 67.6325C88.421 67.7686 91.3777 67.118 93.9864 65.8544L98.7499 72.2524C99.9512 73.9055 102.261 74.2696 103.909 73.0656C105.558 71.8617 105.92 69.5456 104.719 67.8925L99.829 61.3205Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M111.664 17.8039C112.294 18.8126 112.043 20.1374 111.041 20.7714L106.247 23.8434C105.245 24.4774 103.928 24.2246 103.298 23.2159C102.668 22.2072 102.919 20.8824 103.922 20.2484L108.715 17.1764C109.718 16.5424 111.041 16.871 111.664 17.8039Z"
      stroke="var(--jd-color-gray-4)"
      stroke-width="1.2392"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M100.17 9.91352L97.4464 16.2997"
      stroke="var(--jd-color-gray-4)"
      stroke-width="1.2392"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M49.4167 56.18C51.6838 56.18 53.5216 54.3307 53.5216 52.0494C53.5216 49.7681 51.6838 47.9187 49.4167 47.9187C47.1496 47.9187 45.3118 49.7681 45.3118 52.0494C45.3118 54.3307 47.1496 56.18 49.4167 56.18Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M62.5759 61.344H45.387L45.3862 66.5073H62.5751L62.5759 61.344Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M73.1724 69.7773H45.387L45.3862 74.9407H73.1717L73.1724 69.7773Z"
      fill="var(--jd-color-gray-4)"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'

let id = 0
export default defineComponent({
  name: 'DataEmpty',
  setup() {
    const ns = useNamespace('empty')
    return {
      ns,
      id: ++id,
    }
  },
})
</script>
